<script lang="ts" setup>
import type { ComponentSectionsMultiAccordion } from '@autobid/strapi-integration/graphql/graphql'
import type { SectionsMultiAccordion } from '@autobid/strapi-integration/rest/components'

interface Props {
  data: SectionsMultiAccordion | ComponentSectionsMultiAccordion
}

defineProps<Props>()
</script>

<template>
  <SectionsAccordion :data="data" />
</template>
